import { PayloadAction } from '@reduxjs/toolkit';
import { DTOUserTutorialProgress } from '@shared/dto/+user/user_tutorial/dto_tutorial_progress';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateUser } from '../state_user';

export const local_user_tutorial_progress_upsert = (payload: DTOUserTutorialProgress): PayloadAction<DTOUserTutorialProgress> => ({
  type: ENUM__redux_action.USER_TUTORIAL_UPSERT,
  payload,
});

export function init_local_user_tutorial_progress_upsert(state: StateUser, action: PayloadAction<DTOUserTutorialProgress>) {
  state.tutorial_progress = action.payload;
}
